import styled from "styled-components";

export const StyledNotification = styled.div`
  border: 2px solid rgb(192, 25, 150);
  font-size: 25px;
  padding: 10px 50px;
  position: absolute;
  top: -60px;
  border-radius: 5px;
  font-weight: 700;
  background-color: #f2f2f2;
`;

export default StyledNotification;
